import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { match } from 'ts-pattern';

import { Channel, ChannelType } from '../../domain';

const isAllMarketingChannels = (channels: Channel[]) =>
  pipe(
    channels,
    array.every((c) => c.channelType === ChannelType.marketing),
  );

const getFirstChannelName = (channels: Channel[]) =>
  pipe(
    channels,
    array.head, // get the first channel if it exists
    option.map((c) => c.name),
    option.getOrElse(() => 'Unknown Channel'), // fallback to default text
  );

export const useChannelOrChannels = (
  selectedChannels: Channel[],
  marketingChannels: Channel[],
): string =>
  useMemo(
    () =>
      match(selectedChannels)
        .when(
          (c) => c.length === marketingChannels.length && isAllMarketingChannels(c),
          () => 'all marketing channels',
        )
        .when((c) => c.length === 1, getFirstChannelName)
        .otherwise((c) => `${c.length} channels`),
    [selectedChannels, marketingChannels],
  );
